import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import VueQrcode from 'vue-qrcode'

createApp(App).use(router).mount('#app').component('vue-qrcode', VueQrcode)
